import {Component, Injector} from '@angular/core';
import {WidgetDataControllerComponent} from '../../../../Controller/widget-data-controller-component';
import {ApiResponse} from '../../../../../Services/Api/base-api.service';
import {EbitdaApiService} from '../../../../../Services/Api/Finances/Ebitda/ebitda-api.service';
import {EbitdaData, EbitdaReportDto} from '../../../../../Models/Finances/Ebitda/ebitda-report.interface';
import {EbitdaFilters} from '../../../../../Models/Finances/Ebitda/ebitda-filters.model';

@Component({
  selector: 'app-ebitda-widget',
  templateUrl: './ebitda-widget.component.html',
  styleUrls: ['./ebitda-widget.component.scss'],
  standalone: false
})
export class EbitdaWidgetComponent extends WidgetDataControllerComponent<EbitdaData> {

  get widgetData(): EbitdaData {
    return this.data ? this.data : this.fakeData;
  }

  constructor(
    protected override injector: Injector,
    protected ebitdaService: EbitdaApiService,
  ) {
    super(injector, ebitdaService);

    this.getFakeData();
  }


  /**
   * Obtener datos falsos
   *
   */
  getFakeData() {
    this.fakeData = {
      last_importe: 22420.72,
      last_porcentaje: 8.88,
      importe: 40194.15,
      porcentaje: 21.18,
      diferencia_importe: 79.27,
      diferencia_porcentaje: 44.21,
    };
  }


  /**
   * Obtener el EBITDA
   *
   */
  override setData(data: EbitdaReportDto) {
    this.data = data.ebitda;
  }


  /**
   * Obtener datos
   *
   */
  getData(): Promise<ApiResponse> {
    const params: EbitdaFilters = new EbitdaFilters();

    if (this.widgetsManager.filters) {
      params.filtro_local = this.widgetsManager.filters.local?.id || params.filtro_local;
      params.fecha_desde = this.widgetsManager.filters.fecha_inicio || params.fecha_desde;
      params.fecha_hasta = this.widgetsManager.filters.fecha_fin || params.fecha_hasta;
    }

    return this.ebitdaService.getReportEbitda(params, false);
  }

}
